// A `?hazard=<id>` link — what the Slack hazard notices carry
// (Hazards::SlackMessages.map_link) — opens that hazard on the map: the map
// flies to it and its details card opens. Pure, so the parsing and the camera
// are tested without Mapbox; HazardsMapHost keeps the side effects.

import { sharedPoiZoom } from '../helpers/poiSharing';

export const HAZARD_LINK_PARAM = 'hazard';

/** The hazard id a URL names, or null. Hazard ids are numeric; anything else is ignored. */
export function linkedHazardIdFromUrl(currentUrl: string): string | null {
  let value: string | null;
  try {
    value = new URL(currentUrl).searchParams.get(HAZARD_LINK_PARAM);
  } catch (e) {
    return null;
  }
  const id = (value ?? '').trim();
  return /^\d+$/.test(id) ? id : null;
}

export interface HazardLinkCamera {
  center: [number, number];
  zoom: number;
}

/**
 * Where to fly for a linked hazard: onto its pin, framed like a shared POI
 * link (never zooming out). Null when it has no usable position, so the map
 * stays put rather than flying to (0, 0).
 */
export function linkedHazardCamera(
  hazard: { latitude: number | null; longitude: number | null } | null,
  currentZoom: unknown,
): HazardLinkCamera | null {
  if (!hazard || !Number.isFinite(hazard.latitude) || !Number.isFinite(hazard.longitude)) return null;
  return { center: [hazard.longitude as number, hazard.latitude as number], zoom: sharedPoiZoom(currentZoom) };
}
